import { AvailabilityEnum, CompactAvailability } from '../../../modules/products/ProductTypes';
import { ProductColorPackStock } from '../../../modules/products/packs/types/productColorPackStock.types';
import { PaginatedResponse } from '../../../types/request.types';
import { PaginatedEndpointParams } from '../../types';

export type Size = {
  id: string;
  name: string;
  position: number;
};

export type QuantityBySize = {
  id?: string;
  quantity: number;
  size: Size;
};

export type PackWithQuantities = {
  id: string;
  name: string;
  type: CompactAvailability;
  quantitiesBySize: QuantityBySize[];
};

export interface PackQuantitiesWithMultiplier extends PackWithQuantities {
  multiplier?: number;
  stock?: ProductColorPackStock;
  willConsumeStock?: boolean;
}

export enum AllowChangeGrid {
  ALLOW = 'ALLOW',
  DISALLOW = 'DISALLOW',
}

export type ProductColorPackItem = {
  id: string;
  packId: string;
  isValid: boolean;
  type: CompactAvailability;
};

export type ProductColorWithPacks = {
  id: string;
  code: string;
  name: string;
  isImage: boolean;
  imageUrl?: string;
  hexcode?: string;
  allowChangePreOrderGrid: AllowChangeGrid;
  allowChangeImmediateGrid: AllowChangeGrid;

  preOrderSelectedPacks: PackWithQuantities[];

  immediateSelectedPacks: PackWithQuantities[];

  allowPackPartialApplyInPreOrder: boolean;
  allowPackPartialApplyInImmediate: boolean;

  // modelo é preenchido e usado para remoção.
  productColorPacks: ProductColorPackItem[];
};

export type ImmediateAndPreOrderPacks = Pick<
  ProductColorWithPacks,
  'preOrderSelectedPacks' | 'immediateSelectedPacks'
>;

export type ProductColorWithPacksOutput = {
  id: string;
  code: string;
  name: string;
  isImage: boolean;
  imageUrl?: string;
  hexcode?: string;
  allowChangePreOrderGrid: AllowChangeGrid;
  allowChangeImmediateGrid: AllowChangeGrid;

  preOrderSelectedPacks: PackWithQuantities[];
  preOrderEligiblePacks: PackWithQuantities[];

  immediateSelectedPacks: PackWithQuantities[];
  immediateEligiblePacks: PackWithQuantities[];

  // modelo é preenchido e usado para remoção.
  productColorPacks: ProductColorPackItem[];
};

export type UpdateBlockPartialApplicationParams = {
  productColorId: string;
  type: CompactAvailability;
  allowPartialApply: boolean;
};

export type UpdateBlockPartialApplicationFlagParams = {
  index: number;
  productColorId: string;
  packType: CompactAvailability;
  blockPartialApplication: boolean;
};

export interface PageSelectedPacksParams extends PaginatedEndpointParams {
  productColorId: string;
  productColorAvailability: AvailabilityEnum;
  ids?: string[];
  packName?: string;
  withInvalids?: boolean;
}

export interface PageSelectedPacksData {
  id: string;
  name: string;
  willConsumeStock: boolean;
  stock: ProductColorPackStock;
  quantitiesBySize: QuantityBySize[];
}

export type PageSelectedPacksOutput = PaginatedResponse<PageSelectedPacksData>;

interface OfflineProductColorPackOutput {
  id: string;
  packId: string;
  productColorId: string;
  willConsumeStock: boolean;
  stock: {
    totalAmount: number;
    availableAmount: number;
  };
}

export interface FindProductColorPacksToOfflineOutput {
  preOrderProductColorPacks: OfflineProductColorPackOutput[];
  immediateProductColorPacks: OfflineProductColorPackOutput[];
  packs: Array<{
    id: string;
    name: string;
    quantitiesBySize: Array<{
      id: string;
      sizeId: string;
      quantity: number;
    }>;
  }>;
}
